// import TeacherLoginPage from '../teacher/login/TeacherLoginPage.vue';
const TeacherLoginPage = () => import(/* webpackChunkName: "TeacherLoginPage" */ '../teacher/login/TeacherLoginPage.vue');

// import TestUserTeacherLoginPage from '../teacher/login/TestUserTeacherLoginPage.vue';
const TestUserTeacherLoginPage = () => import(/* webpackChunkName: "TestUserTeacherLoginPage" */ '../teacher/login/TestUserTeacherLoginPage.vue');
// import TeacherDashboardPage from '../teacher/dashboard/TeacherDashboardPage.vue';
const TeacherDashboardPage = () => import(/* webpackChunkName: "TeacherDashboardPage" */ '../teacher/dashboard/TeacherDashboardPage.vue');

const TeacherInfoInputMain = () => import(/* webpackChunkName: "TeacherInfoInputMain" */ '../teacher/info/TeacherInfoInputMain.vue');
// import TeacherInfoInputMain from '../teacher/info/TeacherInfoInputMain.vue';
const TeacherTermOfUsePage = () => import(/* webpackChunkName: "TeacherTermOfUsePage" */ '../teacher/register/TeacherTermOfUsePage.vue');
// import TeacherTermOfUsePage from '../teacher/register/TeacherTermOfUsePage.vue';
const LessonReservationCommitPage = () => import(/* webpackChunkName: "LessonReservationCommitPage" */ '../teacher/lesson_reservation_commit/LessonReservationCommitPage.vue');
// import LessonReservationCommitPage from '../teacher/lesson_reservation_commit/LessonReservationCommitPage.vue';
const TeacherLessonStateListPage = () => import(/* webpackChunkName: "TeacherLessonStateListPage" */ '../teacher/lesson_state/TeacherLessonStateListPage.vue');
// import TeacherLessonStateListPage from '../teacher/lesson_state/TeacherLessonStateListPage.vue';
const TeacherDailyReportPage = () => import(/* webpackChunkName: "TeacherDailyReportPage" */ '../teacher/daily_report/TeacherDailyReportPage.vue');
// import TeacherDailyReportPage from '../teacher/daily_report/TeacherDailyReportPage.vue';

const AdditionalInputMainPage = () => import(/* webpackChunkName: "AdditionalInputMainPage" */ '../teacher/additional/AdditionalInputMainPage.vue');
// import AdditionalInputMainPage from '../teacher/additional/AdditionalInputMainPage.vue';
const TeacherRegistComplete = () => import(/* webpackChunkName: "TeacherRegistComplete" */ '../teacher/info/TeacherRegistComplete.vue');
// import TeacherRegistComplete from '../teacher/info/TeacherRegistComplete.vue';
const TeacherAdditionalInfoComplete = () => import(/* webpackChunkName: "TeacherAdditionalInfoComplete" */ '../teacher/additional/TeacherAdditionalInfoComplete.vue');
// import TeacherAdditionalInfoComplete from '../teacher/additional/TeacherAdditionalInfoComplete.vue';

const TeacherLessonScheduleListPage = () => import(/* webpackChunkName: "TeacherLessonScheduleListPage" */ '../teacher/schedule/TeacherLessonScheduleListPage.vue');
// import TeacherLessonScheduleListPage from '../teacher/schedule/TeacherLessonScheduleListPage.vue';
const TeacherDailyReportListPage = () => import(/* webpackChunkName: "TeacherDailyReportListPage" */ '../teacher/daily_report/TeacherDailyReportListPage.vue');
// import TeacherDailyReportListPage from '../teacher/daily_report/TeacherDailyReportListPage.vue';
const SupportPlanPageFroTeacher = () => import(/* webpackChunkName: "SupportPlanPageFroTeacher" */ '../teacher/support_plan/SupportPlanPageFroTeacher.vue');
// import SupportPlanPageFroTeacher from '../teacher/support_plan/SupportPlanPageFroTeacher.vue';
const TeacherSettingPage = () => import(/* webpackChunkName: "TeacherSettingPage" */ '../teacher/setting/TeacherSettingPage.vue');
// import TeacherSettingPage from '../teacher/setting/TeacherSettingPage.vue';
const TeacherPasswordChangePage = () => import(/* webpackChunkName: "TeacherPasswordChangePage" */ '../teacher/setting/TeacherPasswordChangePage.vue');
// import TeacherPasswordChangePage from '../teacher/setting/TeacherPasswordChangePage.vue';
const TeacherBBSPage = () => import(/* webpackChunkName: "TeacherBBSPage" */ '../teacher/bbs/TeacherBBSPage.vue');
// import TeacherBBSPage from '../teacher/bbs/TeacherBBSPage.vue';

const TeacherLessonStateCalendarPage = () => import(/* webpackChunkName: "TeacherLessonStateCalendarPage" */ '../teacher/lesson_state/TeacherLessonStateCalendarPage.vue');
// import TeacherLessonStateCalendarPage from '../teacher/lesson_state/TeacherLessonStateCalendarPage.vue';
const LessonReservationCommitCalendarPage = () => import(/* webpackChunkName: "LessonReservationCommitCalendarPage" */ '../teacher/lesson_reservation_commit/LessonReservationCommitCalendarPage.vue');
// import LessonReservationCommitCalendarPage from '../teacher/lesson_reservation_commit/LessonReservationCommitCalendarPage.vue';
const TeacherMessagesPage = () => import(/* webpackChunkName: "TeacherMessagesPage" */ '../teacher/messages/TeacherMessagesPage.vue');
// import TeacherMessagesPage from '../teacher/messages/TeacherMessagesPage.vue';
export const teacherRouters = [
  {
    path: '/teacher-login-page',
    name: 'TeacherLoginPage',
    component: TeacherLoginPage,
  },
  {
    path: '/test-user-teacher-login-page',
    name: 'TestUserTeacherLoginPage',
    component: TestUserTeacherLoginPage,
  },
  {
    path: '/teacher-info-input-main',
    name: 'TeacherInfoInputMain',
    component: TeacherInfoInputMain,
  },
  {
    path: '/teacher-regist-complete',
    name: 'TeacherRegistComplete',
    component: TeacherRegistComplete,
  },

  {
    path: '/teacher-dashboard-page',
    name: 'TeacherDashboardPage',
    component: TeacherDashboardPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-lesson-state-list-page',
    name: 'TeacherLessonStateListPage',
    component: TeacherLessonStateListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-lesson-state-calendar-page',
    name: 'TeacherLessonStateCalendarPage',
    component: TeacherLessonStateCalendarPage,
    meta: { requireAuth: true },
  },
  {
    path: '/lesson-reservation-commit-page',
    name: 'LessonReservationCommitPage',
    component: LessonReservationCommitPage,
    meta: { requireAuth: true },
  },
  {
    path: '/lesson-reservation-commit-calendar-page',
    name: 'LessonReservationCommitCalendarPage',
    component: LessonReservationCommitCalendarPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-daily-report-page',
    name: 'TeacherDailyReportPage',
    component: TeacherDailyReportPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-lesson-schedule-list-page',
    name: 'TeacherLessonScheduleListPage',
    component: TeacherLessonScheduleListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-daily-report-list-page',
    name: 'TeacherDailyReportListPage',
    component: TeacherDailyReportListPage,
    meta: { requireAuth: true },
  },
  {
    path: '/additional-input-main-page',
    name: 'AdditionalInputMainPage',
    component: AdditionalInputMainPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-additional-info-complete',
    name: 'TeacherAdditionalInfoComplete',
    component: TeacherAdditionalInfoComplete,
    meta: { requireAuth: true },
  },

  {
    path: '/teacher-support-plan-page',
    name: 'SupportPlanPageFroTeacher',
    component: SupportPlanPageFroTeacher,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-term-of-use-page',
    name: 'TeacherTermOfUsePage',
    component: TeacherTermOfUsePage,
    meta: { requireAuth: false },
  },
  {
    path: '/teacher-setting-page',
    name: 'TeacherSettingPage',
    component: TeacherSettingPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-password-change-page',
    name: 'TeacherPasswordChangePage',
    component: TeacherPasswordChangePage,
    meta: { requireAuth: true },
  },

  {
    path: '/teacher-bbs-page',
    name: 'TeacherBBSPage',
    component: TeacherBBSPage,
    meta: { requireAuth: true },
  },
  {
    path: '/teacher-messages-page',
    name: 'TeacherMessagesPage',
    component: TeacherMessagesPage,
    meta: { requireAuth: true },
  },
].map((route) => {
  if (!route.meta) {
    (route as any).meta = {};
  }
  (route.meta as any).type = 'teacher';
  return route;
});
